import React from 'react'
import { PageContext } from 'types/PageContext'
import { Access } from 'utils/Access'
import { assertExists } from 'utils/assert'
import { PageMeta } from 'lib/PageMeta'
import { MemberPage } from 'modules/MemberPage'
import { Reviews } from 'modules/member/reviews/Reviews'
import { preloadUserReviews } from 'modules/reviews/list/queries/useUserReviews'
import { preloadUserFromPath, useUserFromPath } from 'modules/user/queries/user'

export const MemberShowReviewsPage = () => {
  const { data } = useUserFromPath()

  const name = data?.user?.fullName || data?.user?.username || 'User'

  return (
    <>
      <PageMeta title={`${name}'s reviews`} />
      <Reviews />
    </>
  )
}

export default MemberShowReviewsPage

MemberShowReviewsPage.getInitialProps = async ({ apolloClient, query: { username: rawUsername } }: PageContext) => {
  assertExists(rawUsername)
  const username = rawUsername.toString()

  await Promise.all([preloadUserFromPath({ apolloClient, username }), preloadUserReviews({ apolloClient, variables: { username, take: 10 } })])

  return {}
}

MemberShowReviewsPage.getLayout = function getLayout(page: React.ReactElement) {
  return <MemberPage access={Access.Public}>{page}</MemberPage>
}
